module.exports = __webpack_public_path__ + "static/img/icon_perspective.a0bb0d5a.svg";